import { isRouteErrorResponse, Link, useRouteError } from "react-router";

import { ErroApi } from "../api/cliente";
import { servidorIndisponivel } from "../api/subida";
import { useTitulo } from "../app/titulo";

function mensagem(erro: unknown): string {
  if (servidorIndisponivel(erro))
    return "O servidor não respondeu. Confira se ele está de pé e recarregue a página.";
  if (erro instanceof ErroApi) return erro.message;
  if (isRouteErrorResponse(erro)) return erro.statusText || "Página não encontrada.";
  return "Algo deu errado do nosso lado. Tente de novo daqui a pouco.";
}

export function PaginaErro({ naoEncontrada = false }: { naoEncontrada?: boolean }) {
  const erro = useRouteError();
  useTitulo("Erro");
  return (
    <>
      <h1 tabIndex={-1}>Não foi possível continuar</h1>
      <p role="alert">{naoEncontrada ? "Página não encontrada." : mensagem(erro)}</p>
      <p>
        <Link to="/">Voltar ao início</Link>
      </p>
    </>
  );
}
